import React, { useState } from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  Divider,
  Select,
  Grid,
  Typography,
  Card,
  CardContent,
  CardActions,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Alert,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { consultaPacientes } from "../../../services/MyPatientsServices";
import { getDecryptedDataFromSessionStorage } from "../../../utils";
import { SECRET_KEY } from "../../../constants/encriptKey";

export const MyPatientsSearch = ({ onSearch }) => {
  const [errorMessage, setErrorMessage] = useState(null);
  //const idMedico = localStorage.getItem("idMedico");
  const data = getDecryptedDataFromSessionStorage(SECRET_KEY);
  const { idMedico } = data

  const [searchCriteria, setSearchCriteria] = useState({
    idMedico,
    nombre: "",
    apellido: "",
    tipoDocumento: "",
    nroDocumento: "",
    page: 1,
  });

  const handleInputChange = (e) => {
    setSearchCriteria({
      ...searchCriteria,
      [e.target.name]: e.target.value,
    });
  };

  const handleSearch = async () => {
    try {
      const res = await consultaPacientes(searchCriteria);
      const pacientesResult = res.result ? res.result.pacientes : res.result;
      onSearch(pacientesResult);

      if(res.successMessage) setErrorMessage(res.successMessage);
    } catch (error) {
      setErrorMessage("Error general al realizar la búsqueda");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage("");
    handleSearch();
  };

  return (
    <Accordion
      defaultExpanded={true}
      sx={{
        border: "0.5px solid #dddddd",
        padding: "1px",
        boxShadow: "1px 1px #d5d5d5",
        borderRadius: "8px",
        marginBottom: "20px",
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ fontWeight: "500" }}>Filtrar búsqueda</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Card
          sx={{
            border: "0.5px solid #dddddd",
            padding: "1px",
            boxShadow: "1px 1px #d5d5d5",
            width: "100%",
          }}
        >
          <form onSubmit={handleSubmit}>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <TextField
                    label="Nombre"
                    name="nombre"
                    onChange={handleInputChange}
                    value={searchCriteria.nombre}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    label="Apellido"
                    name="apellido"
                    onChange={handleInputChange}
                    value={searchCriteria.apellido}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    sx={{ my: 0, marginBottom: 2 }}
                  >
                    <InputLabel
                      htmlFor="registrationType"
                      sx={{ color: "text.primary" }}
                    >
                      Tipo de Documento{" "}
                    </InputLabel>
                    <Select
                      native
                      onChange={handleInputChange}
                      value={searchCriteria.tipoDocumento}
                      label="Tipo de Documento"
                      inputProps={{
                        name: "tipoDocumento",
                        id: "tipoDocumento",
                      }}
                      sx={{ color: "text.primary" }}
                    >
                      <option value=""></option>
                      <option value="Pasaporte">Pasaporte</option>
                      <option value="DNI">DNI</option>
                      <option value="LE">LE</option>
                      <option value="LC">LC</option>
                      <option value="CI">CI</option>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    label="Número de documento"
                    name="nroDocumento"
                    onChange={handleInputChange}
                    value={searchCriteria.nroDocumento}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardActions sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Stack
                direction="row"
                alignItems="stretch"
                justifyContent="flex-end"
                spacing={2}
              >
                {errorMessage && (
                  <Alert fullWidth severity="error">
                    {errorMessage}
                  </Alert>
                )}
                <LoadingButton
                  loading={false}
                  color="primary"
                  size="small"
                  type="submit"
                  variant="contained"
                >
                  Consultar
                </LoadingButton>
              </Stack>
            </CardActions>
          </form>
        </Card>
      </AccordionDetails>
    </Accordion>
  );
};
